
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/alHilal",
      function () {
        return require("private-next-pages/case-study/alHilal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/alHilal"])
      });
    }
  